import React, { useEffect, useState } from "react";
import ORBApi from "../../../services/ORBApi";
import { toast } from "react-toastify";
import { Button, Grid, TextField } from "@mui/material";
import DateMonthPicker from "../../../components/common/DateMonthPicker";
import { PaymentFilesTable } from "./Tables";
import CurrencysDropdown from "../../../components/common/CurrencyDropdown";
import moment from "moment";

export function NewDistributionPanel(props) {
	// {onSave, distribution, texts}

	const [name, setName] = useState(
		props.distribution ? props.distribution.name : ""
	);
	const [referenceDate, setReferenceDate] = useState(
		props.distribution
			? props.distribution.reference_date
			: moment().format("YYYY-MM")
	);
	const [currency, setCurrency] = useState(
		props.distribution ? props.distribution.currency : ""
	);
	const [pmtFiles, setPmtFiles] = useState({ current_page: 1, reports: [] });
	const [selectedFileIds, setSelectedFileIds] = useState([]);
	const [rawReferenceDate, setRawReferenceDate] = useState(
		props.distribution
			? moment(props.distribution.reference_date, "YYYY-MM").toDate()
			: new Date()
	);

	// function formatDateStringToGMT(dateString) {
	//   const parts = dateString.split('-');
	//   const year = parseInt(parts[0], 10);
	//   const month = parseInt(parts[1], 10);

	//   const formattedDate = new Date(Date.UTC(year, month));

	//   return formattedDate.toUTCString();
	// }

	const saveDistribution = () => {
		if (!props.distribution) {
			// New distribution
			// Filtrar valores inválidos e validar que pelo menos um arquivo foi selecionado
			const validFileIds = selectedFileIds.filter((id) => id != null && id !== undefined);
			if (!validFileIds || validFileIds.length === 0) {
				toast.error("Por favor, selecione pelo menos um arquivo para distribuir");
				return;
			}

			ORBApi.postDistribution(name, referenceDate, currency, validFileIds)
				.then(() => {
					toast.success(props.messages.created);
					props.onSave();
				})
				.catch((error) => {
					// Tentar extrair mensagem de erro mais específica do backend
					let errorMessage = props.messages.create_failed;
					if (error?.response?.data?.description) {
						errorMessage = error.response.data.description;
					} else if (error?.response?.data?.message) {
						errorMessage = error.response.data.message;
					} else if (error?.response?.data?.error) {
						errorMessage = error.response.data.error;
					} else if (error?.message) {
						errorMessage = error.message;
					}
					console.error('Error creating distribution:', error);
					toast.error(errorMessage);
				});
		} else {
			// Just editing a distribution
			// When user do not edit the date, reference date still have the yyyy-mm-dd format
			var refDate = referenceDate;
			if (refDate.length > 7) refDate = refDate.substring(0, 7);
			ORBApi.updateDistribution(props.distribution.id, name, refDate, currency)
				.then(() => {
					toast.success(props.messages.updated);
					props.onSave();
				})
				.catch(() => {
					toast.error(props.messages.update_failed);
				});
		}
	};

	const hasAutoSelected = React.useRef(false);

	const loadPaymentFiles = (page) => {
		ORBApi.loadFilesToDistribute(page, { status: 4 }) // show only files with status == 4 ( ready )
			.then((data) => {
				setPmtFiles(data);
				// Apenas na primeira carga, se não houve seleção automática ainda
				if (!hasAutoSelected.current && data.reports && data.reports.length > 0) {
					const firstFile = data.reports[0];
					if (firstFile && firstFile.id != null) {
						setSelectedFileIds([firstFile.id]);
						hasAutoSelected.current = true; // Marca como já realizado
					}
				}
			})
			.catch(() => {
				toast.error(props.messages.payment_files_load_failed);
				// Limpar seleção em caso de erro
				setSelectedFileIds([]);
			});
	};

	const handleFileSelect = (fileId) => {
		// Validar que o fileId é válido antes de processar
		if (fileId == null || fileId === undefined) {
			console.warn('Invalid fileId received:', fileId);
			return;
		}
		setSelectedFileIds((prevIds) => {
			// Filtrar valores inválidos do array atual
			const validIds = prevIds.filter((id) => id != null && id !== undefined);
			if (validIds.includes(fileId)) {
				// Remover se já estiver selecionado
				return validIds.filter((id) => id !== fileId);
			} else {
				// Adicionar se não estiver selecionado
				return [...validIds, fileId];
			}
		});
	};

	useEffect(() => {
		if (!props.distribution) loadPaymentFiles(1); // only show pmt files when creating
	}, []);

	return (
		<>
			<div className="modal-container new-distribution">
				<h4>
					{props.distribution ? props.texts.form_title_edit : props.texts.form_title}
				</h4>
				<hr />
				<Grid container spacing={2} alignItems="center">
					<Grid item xs={12} md={4} style={{ marginBottom: "5px" }}>
						<DateMonthPicker
							label={props.texts.form_input_names.reference_date}
							required
							format="MM/yyyy"
							view={["month", "year"]}
							value={rawReferenceDate}
							onChange={(rawDate, date) => {
								if (rawDate) {
									setRawReferenceDate(rawDate);
									setReferenceDate(date);
								}
							}}
						/>
					</Grid>
					<Grid item xs={12} md={4}>
						<TextField
							variant="outlined"
							label={props.texts.form_input_names.distribution_name}
							fullWidth
							required
							value={name}
							onChange={(e) => {
								setName(e.target.value);
							}}
						/>
					</Grid>
					<Grid item xs={12} md={4}>
						<CurrencysDropdown
							value={currency}
							onChange={(value) => setCurrency(value)}
						/>
					</Grid>
					<Grid item xs={12}>
						{!props.distribution ? (
							<>
								<h6>{props.texts.form_table_title}</h6>
								<PaymentFilesTable
									header_table={props.texts.form_header}
									data={pmtFiles}
									onPageChange={loadPaymentFiles}
									selectedFileIds={selectedFileIds}
									onFileSelect={handleFileSelect}
								/>
							</>
						) : null}
					</Grid>

					<Grid item xs={12} md={4}>
						<Button
							fullWidth
							size="large"
							variant="contained"
							color="secondary"
							onClick={saveDistribution}
						>
							{props.distribution ? props.texts.edit_button : props.texts.save_button}
						</Button>
					</Grid>
				</Grid>
			</div>
		</>
	);
}
